/* eslint-disable no-unused-vars */
import { getStore } from './services/store';
import { App } from './services/action';
import moment from 'moment';
var idLocale = require('moment/locale/id');

moment.locale('id', idLocale);

export default async function bootstrap() {
  const { dispatch } = getStore();

  await dispatch(App.$appReady());
}
